module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_6.4f19199e.jpg";